// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://uebhsswzziriuxrxevtk.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVlYmhzc3d6emlyaXV4cnhldnRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk4MzE0NzYsImV4cCI6MjA2NTQwNzQ3Nn0.cVJqeWAJ6aLbgdR0bETw68qXw1IAGhBwHG9kHXIHfD8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);